import { createBrowserRouter } from "react-router-dom";
import IndexLayout from "../layouts/IndexLayout";
import MainLayout from "../layouts/MainLayout";
import PagesLayaut from '../layouts/PagesLayaut';
import PagesLayautMobile from '../layouts/PagesLayautMobile';
import Productos from '../pages/Productos/Productos';
import Usuarios from '../pages/Usuarios/Usuarios';
import Clientes from '../pages/Clientes/Clientes';
import TiposCliente from '../pages/TiposCliente/TiposCliente';
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import PageDetail from '../pages/PageDetail/PageDetail';
import PageProductos from "./PageProductos/PageProductos";
import Pedidos from "./Pedidos/Pedidos";
import ListaCategoria from "../components/ListaCategoria/ListaCategoria";
import PageProductosCatalogo from "./PageProductosCatalogo/PageProductosCatalogo";
import useScreenSize from "../utils/useScreenSize";
import PasarelaPagos from "./PasarelaPagos/PasarelaPagos";
import PedidoPagado from "../components/PedidoPagado/PedidoPagado";

const getRoutes = (isMobile, logo, backgroundCatalog, config) => {
    const commonRoutes = [
        {
            path: "/",
            element: <MainLayout logo={logo} />,
            children: [
                {
                    path: `dashboard`,
                    element: <Main />,
                },
                {
                    path: `dashboard/productos`,
                    element: <Productos />,
                },
                {
                    path: `dashboard/usuarios`,
                    element: <Usuarios />,
                },
                {
                    path: `dashboard/banners`,
                    element: <Banners />,
                },
                {
                    path: `dashboard/contacto`,
                    element: <Contacto />,
                },
                {
                    path: `dashboard/pasarelaPagos`,
                    element: <PasarelaPagos />,
                },
                {
                    path: `dashboard/categorias`,
                    element: <Categorias />,
                },
                {
                    path: `dashboard/codigos`,
                    element: <Codigos />,
                },
                {
                    path: `dashboard/pedidos`,
                    element: <Pedidos />,
                },
                {
                    path: `dashboard/clientes`,
                    element: <Clientes />,
                },
                {
                    path: `dashboard/tiposCliente`,
                    element: <TiposCliente />,
                },
            ],
        },
        {
            path: "/",
            element: <PagesLayaut logo={logo} />,
            children: [
                {
                    path: `producto/:idProducto/:producto/*`,
                    element: <PageDetail />,
                },
            ],
        }
    ];

    // Leer configuración del catálogo
    const showCategoryMenu = config?.Catalog?.showCategoryMenu !== false;
    const enableCatalogView = config?.Catalog?.enableCatalogView !== false;

    // Determinar qué mostrar en móvil basado en la configuración
    if (isMobile) {
        // Si se debe mostrar el menú de categorías en móvil
        if (showCategoryMenu) {
            return [
                {
                    path: "/",
                    element: <ListaCategoria logo={logo} backgroundCatalog={backgroundCatalog} />,
                },
                ...commonRoutes,
                {
                    path: "/",
                    element: enableCatalogView ? <PagesLayautMobile logo={logo} /> : <PagesLayaut logo={logo} />,
                    children: [
                        {
                            path: `productos`,
                            element: enableCatalogView ? <PageProductosCatalogo /> : <PageProductos />,
                        },
                        {
                            path: "/pedido",
                            element: <PedidoPagado/>,
                        },
                    ],
                },
            ];
        } else {
            // Sin menú de categorías, ir directo a la vista correspondiente
            return [
                {
                    path: "/",
                    element: enableCatalogView ? <ListaCategoria logo={logo} backgroundCatalog={backgroundCatalog} /> : <IndexLayout logo={logo} />,
                },
                ...commonRoutes,
                {
                    path: "/",
                    element: enableCatalogView ? <PagesLayautMobile logo={logo} /> : <PagesLayaut logo={logo} />,
                    children: [
                        {
                            path: `productos`,
                            element: enableCatalogView ? <PageProductosCatalogo /> : <PageProductos />,
                        },
                        {
                            path: "/pedido",
                            element: <PedidoPagado/>,
                        },
                    ],
                },
            ];
        }
    } else {
        // Vista desktop (sin cambios)
        return [
            {
                path: "/",
                element: <IndexLayout logo={logo} />,
            },
            ...commonRoutes,
            {
                path: "/",
                element: <PagesLayaut logo={logo} />,
                children: [
                    {
                        path: `productos`,
                        element: <PageProductos />,
                    },
                    {
                        path: "/pedido",
                        element: <PedidoPagado/>,
                    },
                ],
            },
        ];
    }
};

// Componente que renderiza las rutas según el tamaño de pantalla y configuración
export const RouterWrapper = (logo, backgroundCatalog, config) => {
    const { isMobile } = useScreenSize();
    const router = createBrowserRouter(getRoutes(isMobile, logo, backgroundCatalog, config));
    return router;
};